import type React from 'react';
import classNames from 'classnames';

import { Box } from 'ui/box';

import Icons from 'assets/icons';

const COLOR_TRANSITION_SX = {
  transitionProperty:
    'color, background-color, border-color, text-decoration-color, fill, stroke',
  transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
  transitionDuration: '100ms',
};

interface CheckboxIconProps {
  isSelected: boolean;
}

const CheckboxIcon = ({ isSelected }: CheckboxIconProps): React.JSX.Element => (
  <Box
    component="span"
    sx={[
      {
        display: 'flex',
        flexShrink: 0,
        alignItems: 'center',
        justifyContent: 'center',
        width: '1rem',
        height: '1rem',
        borderRadius: '0.25rem',
        borderWidth: '2px',
        ...COLOR_TRANSITION_SX,
      },
      isSelected && {
        borderColor: 'tokens.navy.600',
        bgcolor: 'tokens.navy.600',
      },
      !isSelected && { borderColor: 'tokens.gray.300' },
    ]}
  >
    <Icons.Check
      customClass={classNames(
        'w-2.5 h-2.5 text-white transition-opacity duration-100',
        isSelected ? 'opacity-100' : 'opacity-0'
      )}
    />
  </Box>
);

export default CheckboxIcon;
